//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion


import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { Enums } from "../../../../models/common"
import { OpDataType } from "../../../../models/core"
import { LocalizationHelper } from "../../../../helpers/"


export class DataTypeClassIntegerRule implements IDataTypePanelRule {

    private static get dataTypeClass(): number { return Enums.DataTypeClass.Integer }

    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(opDataType != null && opDataType.idDataTypeClass === DataTypeClassIntegerRule.dataTypeClass).promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        if (opDataType != null) {
            const item: IMRDataTypePanelFormItemOptions = {
                dataField: opDataType.idDataType.toString(),
                editorType: 'dxNumberBox',
                validationRules: this.getDataTypeRuleOptions(opDataType, isRequired),

                editorOptions: {
                    value: _.first(data),
                },

                label: {
                    location: 'top',
                    text: opDataType.toString()
                },
            }

            return $.Deferred().resolve(item).promise()
        }

        return $.Deferred().resolve(null).promise()
    }

    //#endregion


    //#region Private Methods

    private getDataTypeRuleOptions(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (!opDataType.referenceType && opDataType.dataTypeFormat != null) {
            validationRules.push({
                type: 'pattern',
                pattern: '^[0-9]{0,}$',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IntegerField)
            })

            if (opDataType.dataTypeFormat.numberMaxValue) {
                validationRules.push({
                    type: 'range',
                    max: opDataType.dataTypeFormat.numberMaxValue,
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberMaxValue) + ' ' + opDataType.dataTypeFormat.numberMaxValue
                })
            }

            if (opDataType.dataTypeFormat.numberMinValue) {
                validationRules.push({
                    type: 'range',
                    min: opDataType.dataTypeFormat.numberMinValue,
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberMinValue) + ' ' + opDataType.dataTypeFormat.numberMinValue
                })
            }
        }

        if (isRequired) {
            validationRules.push({
                type: 'required',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }

    //#endregion

}